import React from "react";
import "../Styling/Shimmer.css";
import "../Styling/Hr_Dashboard.css";

const ShimmerBlock = ({ className, height }) => (
  <div className={`shimmer-block ${className}`} style={{ height }} />
);

const ShimmerDashboard = () => {
  return (
    <div className="container-fluid py-4 hr-dashboard-page">

      {/* Header */}
      <div className="hr-analytics-shimmer mb-3">
        <ShimmerBlock height="30px" style={{ width: "250px" }} />
      </div>

      {/* Filters */}
      <div className="shimmer-filters mb-3">
        <ShimmerBlock height="70px" />
      </div>

      <div className="row g-3 mt-3">

        {/* LEFT PANEL (HR PERSONAL) */}
        <div className="col-lg-4 col-md-12">
          <div className="hr-personal-panel">
            <ShimmerBlock height="20px" className="mb-3" />
            <ShimmerBlock height="80px" className="mb-3" />
            <ShimmerBlock height="80px" className="mb-3" />
            <ShimmerBlock height="80px" className="mb-3" />
            <ShimmerBlock height="80px" />
          </div>
        </div>

        {/* RIGHT WORKSPACE */}
        <div className="col-lg-8 col-md-12">
          <div className="row g-3">

            <div className="col-md-6">
              <ShimmerBlock height="140px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="140px" />
            </div>

            <div className="col-12">
              <ShimmerBlock height="120px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="180px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="180px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="160px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="160px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="160px" />
            </div>

            <div className="col-md-6">
              <ShimmerBlock height="160px" />
            </div>

          </div>
        </div>

        {/* Bottom Growth Chart */}
        <div className="col-12 mt-3">
          <ShimmerBlock height="300px" />
        </div>

      </div>
    </div>
  );
};

export default ShimmerDashboard;